module.exports = __webpack_public_path__ + "16d9bcaa93dde49e2d0c4ed5e0f20c7c.svg";